export const LoadingSpinner = () => {
  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="h-14 w-14 animate-spin rounded-full border-8 border-t-8 border-gray-400 border-t-white"></div>
    </div>
  );
};
